import PropTypes from 'prop-types'
import { memo } from 'react'
import styles from './BorderCorner.module.scss'

/**
 * The `BorderCorner` renders the base border of the HUD
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function BorderCorner (props) {
  const { clipId } = props

  return (
    <svg className={styles.svg} aria-hidden="true">
      <defs>
        <clipPath id={clipId} clipPathUnits="objectBoundingBox">
          <path d="M1,0 H0 v1 C0,0.44,0.44,0,1,0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

/** @type {object} */
BorderCorner.propTypes = {
  clipId: PropTypes.string.isRequired
}

// Memoize
export default memo(BorderCorner)
